<script context="module" lang="ts">
    import { registerFileCommands } from "$lib/commands/file";
    import { registerEditCommands } from "$lib/commands/edit";
    import { registerLayerCommands } from "$lib/commands/layers";
    import { registerTimelineCommands } from "$lib/commands/animation";
    import { registerPaletteCommands } from "$lib/commands/palette";

    registerFileCommands();
    registerLayerCommands();
    registerPaletteCommands();
    registerEditCommands();
    registerTimelineCommands();


    import { wasmPromise } from "$lib/wasm/wasm";
    wasmPromise;
</script>

<script lang="ts">
    import { file } from "../state";

    import Canvas from "$lib/image/Canvas.svelte";

    export let state: { pan: Vec2, scale: number } = { pan: { x: 0, y: 0 }, scale: 1 };

</script>
<!----------------------------------------------------------------------------->

{#await wasmPromise}
    <span>Loading WASM...</span>
{:then _}
    {#if $file}
        {#key $file}
            <Canvas {state} file={$file} />
        {/key}
    {/if}
{/await}

<!----------------------------------------------------------------------------->

<style></style>
